var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{attrs:{"color":"teal"},on:{"click":_vm.download}},[_vm._v("cloud_download")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }